<template>
  <div class="freightOrderCreate">
    <van-form label-width="120px">
      <div class="freightOrderCreate-title">{{ $t.meta.basicTitle }}</div>

      <van-field
        v-model="form.Customer.text"
        :label="$t.salesManagement.entrustEnterprise"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showCustomer')"
        clickable
        readonly
        v-if="!CustomerId"
      />

      <van-field
        v-model="form.QuotationRefNumber"
        :label="$t.salesManagement.qrNumber"
        label-class="number-label"
        :placeholder="$t.meta.input"
        v-if="!isEdit"
        disabled
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.QuotationRefNumber)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.meta.businessType }}</div>
        <van-radio-group
          v-model="form.BusinessType"
          direction="horizontal"
          @change="getCountrys"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-title">
        {{ $t.salesManagement.deliveryCity }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.Delivery.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDeliveryCountry')"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        clickable
        readonly
        :value="form.Delivery.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDeliveryCity')"
        :disabled="!isEdit ? true : false"
      />

      <div class="freightOrderCreate-title">
        {{ $t.salesManagement.destinationCity }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.Destination.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDestinationCountry')"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        clickable
        readonly
        :value="form.Destination.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showDestinationCity')"
        :disabled="!isEdit ? true : false"
      />

      <div class="freightOrderCreate-title">
        {{ $t.salesManagement.title2 }}
      </div>

      <van-field
        v-model="form.GoodsName"
        :label="$t.salesManagement.goodsName"
        :placeholder="$t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.TCName"
        :label="$t.salesManagement.tradeTerms"
        @click="pickerShow('showTCIdPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :disabled="!isEdit ? true : false"
      />

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.brand }}</div>
        <van-radio-group
          v-model="form.Brand"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.liquid }}</div>
        <van-radio-group
          v-model="form.Liquid"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.powder }}</div>
        <van-radio-group
          v-model="form.Powder"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.magnetic }}</div>
        <van-radio-group
          v-model="form.Magnetic"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.entrustType }}</div>
        <van-radio-group
          v-model="form.ExportType"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.salesManagement.export1 }}</van-radio>
          <van-radio :name="2">{{ $t.salesManagement.export2 }}</van-radio>
          <van-radio :name="3">{{ $t.salesManagement.export3 }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        v-model="form.NumberPackages.number"
        :label="$t.salesManagement.pNumber"
        :placeholder="$t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.NumberPackages.text"
        :label="$t.salesManagement.piecesUnit"
        @click="pickerShow('showNumberPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.Volume.number"
        :label="$t.salesManagement.volume"
        :placeholder="$t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.Volume.text"
        :label="$t.salesManagement.volumeUnit"
        @click="pickerShow('showVolumePicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.Weight.number"
        :label="$t.salesManagement.weight"
        :placeholder="$t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.Weight.text"
        :label="$t.salesManagement.weightUnit"
        @click="pickerShow('showWeightPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.ECDName"
        :label="$t.salesManagement.commission"
        @click="pickerShow('showECDIdPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        :disabled="!isEdit ? true : false"
      />

      <div class="freightOrderCreate-radio">
        <div class="radio-label">{{ $t.salesManagement.tdService }}</div>
        <van-radio-group
          v-model="form.TakeDeliveryService"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="freightOrderCreate-title" v-if="form.TakeDeliveryService == 1">
        {{ $t.salesManagement.tdLocation }}
      </div>

      <van-field
        clickable
        readonly
        :value="form.TakeDelivery.CountryText"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showTakeDeliveryCountry')"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        clickable
        readonly
        :value="form.TakeDelivery.CityText"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        :disabled="!isEdit ? true : false"
        @click="onShowEmit('showTakeDeliveryCity')"
        v-if="form.TakeDeliveryService == 1"
      />

      <van-field
        v-model="form.TakeDeliveryAddress"
        :label="$t.salesManagement.takeDeliveryAddress"
        :placeholder="$t.meta.input"
        :disabled="!isEdit ? true : false"
        type="textarea"
        v-if="form.TakeDeliveryService == 1"
      />

      <div style="margin: 16px" v-if="isEdit">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <!-- 发货地 -->
    <option-list
      event="showDeliveryCountry"
      :options="countryList"
      @onSelect="onSelectDeliveryCountry"
    ></option-list>

    <option-list
      event="showDeliveryCity"
      :options="deliveryCityList"
      @onSelect="onSelectDeliveryCity"
    ></option-list>

    <!-- 目的地 -->
    <option-list
      event="showDestinationCountry"
      :options="countryList"
      @onSelect="onSelectDestinationCountry"
    ></option-list>

    <option-list
      event="showDestinationCity"
      :options="destinationCityList"
      @onSelect="onSelectDestinationCity"
    ></option-list>

    <!-- 提货地点 -->
    <option-list
      event="showTakeDeliveryCountry"
      :options="countryList"
      @onSelect="onSelectTakeDeliveryCountry"
    ></option-list>

    <option-list
      event="showTakeDeliveryCity"
      :options="takeDeliveryCityList"
      @onSelect="onSelectTakeDeliveryCity"
    ></option-list>

    <van-popup v-model="showTCIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.tradeTerms"
        show-toolbar
        :columns="tcList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="tcidConfirm"
        @cancel="showTCIdPicker = false"
      />
    </van-popup>

    <van-popup v-model="showNumberPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.piecesUnit"
        show-toolbar
        :columns="packageList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="numberConfirm"
        @cancel="showNumberPicker = false"
      />
    </van-popup>

    <van-popup v-model="showVolumePicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.volumeUnit"
        show-toolbar
        :columns="volumeList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="volumeConfirm"
        @cancel="showVolumePicker = false"
      />
    </van-popup>

    <van-popup v-model="showWeightPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.weightUnit"
        show-toolbar
        :columns="weightList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="weightConfirm"
        @cancel="showWeightPicker = false"
      />
    </van-popup>

    <van-popup v-model="showECDIdPicker" round position="bottom">
      <van-picker
        :title="$t.salesManagement.commission"
        show-toolbar
        :columns="ecdList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="ecdConfirm"
        @cancel="showECDIdPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "freightOrderCreate",
  components: {
    OptionList,
  },
  data() {
    return {
      isEdit: false,
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      content: {},
      form: {
        QRId: "",
        BusinessType: 1,
        Delivery: {},
        Destination: {},
        GoodsName: "",
        TCName: "",
        TCId: "",
        NumberPackages: {
          number: null,
          text: "",
          value: "",
        },
        Volume: {
          number: null,
          text: "",
          value: "",
        },
        Weight: {
          number: null,
          text: "",
          value: "",
        },
        Brand: 0,
        Liquid: 0,
        Powder: 0,
        Magnetic: 0,
        ExportType: 2,
        TakeDeliveryService: 0,
        TakeDelivery: {},
        TakeDeliveryAddress: "",
        ECDName: "",
        ECDId: "",
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      },
      //国家城市选项
      countryList: [],
      deliveryCityList: [],
      destinationCityList: [],
      takeDeliveryCityList: [],
      //货运选项
      settings: [],
      tcList: [],
      ecdList: [],
      packageList: [],
      volumeList: [],
      weightList: [],
      //picker
      showTCIdPicker: false,
      showNumberPicker: false,
      showVolumePicker: false,
      showWeightPicker: false,
      showECDIdPicker: false,
      showItemPicker: false,
    };
  },
  created() {
    const { QRId } = this.$route.query;
    this.form.QRId = QRId;
    if (this.form.QRId) {
      this.isEdit = false;
      this.getQuotationReferenceInfo().then((success) => {
        this.getOptions().then((success) => {
          if (success) {
            this.getCities("delivery", this.content.DeliveryCountryId, false);
            this.getCities("destination", this.content.DestinationCountryId, false);
            this.getCities("pickup", this.content.TakeDeliveryCountry, false);
            this.applyData(this.content);
          }
        });
      });
    } else {
      this.isEdit = true;
      this.getOptions();
    }
  },
  methods: {
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountrys(), this.getEntrustOrderSetting()])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getQuotationReferenceInfo() {
      return new Promise((resolve, reject) => {
        var param = {
          QRId: this.form.QRId,
        };
        this.$api.myCustomer
          .getQuotationReferenceInfo(param)
          .then((res) => {
            this.content = res.data;
            this.form.BusinessType = this.content.BusinessType;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.QuotationRefNumber = data.QuotationRefNumber;
      this.form.Brand = parseInt(data.Brand);
      this.form.Liquid = parseInt(data.Liquid);
      this.form.Powder = parseInt(data.Powder);
      this.form.Magnetic = parseInt(data.Magnetic);
      this.form.ExportType = parseInt(data.ExportType);
      this.form.TakeDeliveryService = parseInt(data.TakeDeliveryService);
      this.form.TakeDeliveryAddress = data.TakeDeliveryAddress;
      this.form.GoodsName = data.GoodsName;

      this.form.Delivery.CountryId = data.DeliveryCountryId;
      var country1 = this.countryList.find((c) => c.value == data.DeliveryCountryId);
      if (country1) {
        this.form.Delivery.CountryText = country1.text;
      }

      this.form.Delivery.CityId = data.DeliveryCityId;
      var city1 = this.deliveryCityList.find((c) => c.value == data.DeliveryCityId);
      if (city1) {
        this.form.Delivery.CityText = city1.text;
      }

      this.form.Destination.CountryId = data.DestinationCountryId;
      var country2 = this.countryList.find((c) => c.value == data.DestinationCountryId);
      if (country2) {
        this.form.Destination.CountryText = country2.text;
      }

      this.form.Destination.CityId = data.DestinationCityId;
      var city2 = this.destinationCityList.find((c) => c.value == data.DestinationCityId);
      if (city2) {
        this.form.Destination.CityText = city2.text;
      }

      this.form.TakeDelivery.CountryId = data.TakeDeliveryCountry;
      var country3 = this.countryList.find((c) => c.value == data.TakeDeliveryCountry);
      if (country3) {
        this.form.TakeDelivery.CountryText = country3.text;
      }

      this.form.TakeDelivery.CityId = data.TakeDeliveryCity;
      var city3 = this.takeDeliveryCityList.find((c) => c.value == data.TakeDeliveryCity);
      if (city3) {
        this.form.TakeDelivery.CityText = city3.text;
      }
      this.form.TCId = data.TCId;
      var tc = this.tcList.find((c) => c.value == data.TCId);
      if (tc) {
        this.form.TCName = tc.text;
      }
      this.form.ECDId = data.ECDId;
      var ecd = this.ecdList.find((c) => c.value == data.ECDId);
      if (ecd) {
        this.form.ECDName = ecd.text;
      }
      this.form.NumberPackages.number = data.NumberPackages;
      var packages = this.packageList.find((c) => c.value == data.NPUId);
      if (packages) {
        this.form.NumberPackages.text = packages.text;
        this.form.NumberPackages.value = packages.value;
      }
      this.form.Volume.number = data.Volume;
      var volume = this.volumeList.find((c) => c.value == data.VUId);
      if (volume) {
        this.form.Volume.text = volume.text;
        this.form.Volume.value = volume.value;
      }
      this.form.Weight.number = data.Weight;
      var weight = this.weightList.find((c) => c.value == data.WUId);
      if (weight) {
        this.form.Weight.text = weight.text;
        this.form.Weight.value = weight.value;
      }
    },
    getEntrustOrderSetting() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.salesManagement
          .getEntrustOrderSetting()
          .then((res) => {
            this.settings = res.data;

            var tcList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.TCName,
                value: item.TCId,
              };
              tcList.push(data);
            });
            this.tcList = this.$commonMethod.deepClone(tcList);

            var ecdList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.ECDName,
                value: item.ECDId,
              };
              ecdList.push(data);
            });
            this.ecdList = this.$commonMethod.deepClone(ecdList);

            var packageList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.NPUId,
              };
              packageList.push(data);
            });
            this.packageList = this.$commonMethod.deepClone(packageList);

            var volumeList = [];
            this.settings[4].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.VUId,
              };
              volumeList.push(data);
            });
            this.volumeList = this.$commonMethod.deepClone(volumeList);

            var weightList = [];
            this.settings[5].forEach((item) => {
              let data = {
                text: item.UnitName,
                value: item.WUId,
              };
              weightList.push(data);
            });
            this.weightList = this.$commonMethod.deepClone(weightList);

            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName) {
      if (!this.isEdit) {
        return;
      }
      this[pickerName] = true;
    },
    tcidConfirm(e) {
      this.form.TCName = e.text;
      this.form.TCId = e.value;
      this.showTCIdPicker = false;
    },
    numberConfirm(e) {
      this.form.NumberPackages.text = e.text;
      this.form.NumberPackages.value = e.value;
      this.showNumberPicker = false;
    },
    volumeConfirm(e) {
      this.form.Volume.text = e.text;
      this.form.Volume.value = e.value;
      this.showVolumePicker = false;
    },
    weightConfirm(e) {
      this.form.Weight.text = e.text;
      this.form.Weight.value = e.value;
      this.showWeightPicker = false;
    },
    ecdConfirm(e) {
      this.form.ECDName = e.text;
      this.form.ECDId = e.value;
      this.showECDIdPicker = false;
    },
    //发货地
    onSelectDeliveryCountry(e) {
      this.form.Delivery.CountryText = e.text;
      this.form.Delivery.CountryId = e.value;
      this.getCities("delivery", e.value);
      this.$forceUpdate();
    },
    onSelectDeliveryCity(e) {
      this.form.Delivery.CityText = e.text;
      this.form.Delivery.CityId = e.value;
      this.$forceUpdate();
    },
    //目的地
    onSelectDestinationCountry(e) {
      this.form.Destination.CountryText = e.text;
      this.form.Destination.CountryId = e.value;
      this.getCities("destination", e.value);
      this.$forceUpdate();
    },
    onSelectDestinationCity(e) {
      this.form.Destination.CityText = e.text;
      this.form.Destination.CityId = e.value;
      this.$forceUpdate();
    },
    //提货地点
    onSelectTakeDeliveryCountry(e) {
      this.form.TakeDelivery.CountryText = e.text;
      this.form.TakeDelivery.CountryId = e.value;
      this.getCities("pickup", e.value);
      this.$forceUpdate();
    },
    onSelectTakeDeliveryCity(e) {
      this.form.TakeDelivery.CityText = e.text;
      this.form.TakeDelivery.CityId = e.value;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      if (!this.isEdit) {
        return;
      }
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      var param = {
        CustomerId: this.CustomerId,
        BusinessType: this.form.BusinessType,
        DeliveryCountryId: this.form.Delivery.CountryId,
        DeliveryCityId: this.form.Delivery.CityId,
        DestinationCountryId: this.form.Destination.CountryId,
        DestinationCityId: this.form.Destination.CityId,
        GoodsName: this.form.GoodsName,
        TCId: parseInt(this.form.TCId),
        NumberPackages: parseInt(this.form.NumberPackages.number),
        NPUId: parseInt(this.form.NumberPackages.value),
        Volume: parseFloat(this.form.Volume.number),
        VUId: parseInt(this.form.Volume.value),
        Weight: parseFloat(this.form.Weight.number),
        WUId: parseInt(this.form.Weight.value),
        Brand: this.form.Brand,
        Liquid: this.form.Liquid,
        Powder: this.form.Powder,
        Magnetic: this.form.Magnetic,
        ExportType: this.form.ExportType,
        TakeDeliveryService: this.form.TakeDeliveryService,
        TakeDeliveryCountry: this.form.TakeDelivery.CountryId,
        TakeDeliveryCity: this.form.TakeDelivery.CityId,
        TakeDeliveryAddress: this.form.TakeDeliveryAddress,
        ECDId: parseInt(this.form.ECDId),
        UserId: this.form.UserId,
        CompanyId: this.form.CompanyId,
      };
      this.$commonMethod.showLoading();
      this.$api.myCustomer
        .addQuotationReference(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onClearArea() {
      this.form.Delivery.CountryText = "";
      this.form.Delivery.CountryId = null;
      this.form.Delivery.CityText = "";
      this.form.Delivery.CityId = null;
      this.form.Destination.CountryText = "";
      this.form.Destination.CountryId = null;
      this.form.Destination.CityText = "";
      this.form.Destination.CityId = null;
      this.form.TakeDelivery.CountryText = "";
      this.form.TakeDelivery.CountryId = null;
      this.form.TakeDelivery.CityText = "";
      this.form.TakeDelivery.CityId = null;
    },
    getCountrys() {
      return new Promise((resolve) => {
        let param = {
          BusinessType: this.form.BusinessType,
        };
        this.$api.myCustomer
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + " , " + item.CountryName_en,
                value: item.CountryId,
                CityList: item.CityList,
              };
              result.push(data);
            });
            this.countryList = result;
            this.onClearArea();
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCities(type, countryId) {
      var formatCity = (cities) => {
        var result = [];
        cities.forEach((item) => {
          let data = {
            text: item.City_cn + " , " + item.City_en,
            value: item.CityId,
          };
          result.push(data);
        });
        return result;
      };
      for (let country of this.countryList) {
        if (country.value == countryId) {
          if (type == "delivery") {
            this.deliveryCityList = formatCity(country.CityList);
            this.form.Delivery.CityText = "";
            this.form.Delivery.CityId = null;
          }
          if (type == "destination") {
            this.destinationCityList = formatCity(country.CityList);
            this.form.Destination.CityText = "";
            this.form.Destination.CityId = null;
          }
          if (type == "pickup") {
            this.takeDeliveryCityList = formatCity(country.CityList);
            this.form.TakeDelivery.CityText = "";
            this.form.TakeDelivery.CityId = null;
          }
        }
      }
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.freightOrderCreate {
  ::v-deep .number-label {
    line-height: 33px;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;

    .van-button {
      padding: 6px 8px;
      height: auto;

      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
    }
  }

  .van-cell::after {
    border: none !important;
  }

  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }

  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #323233 !important;
  }

  .freightOrderCreate-title {
    font-size: 14px;
    padding: 15px;
    color: #1890ff;
    background: #f1f1f1;

    .title-left {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      color: #1890ff;
    }

    .title-right {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      text-align: right;
      color: #999;

      .van-switch {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }

      .later {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .freightOrderCreate-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;

    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }

    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
}
</style>
